<!-- summary-card.html -->
<app-card-mask [hasMask]="hasMask || !!data.comingSoon">
  <mat-card class="summary-card" [style.--border-color]="data.borderColor">
    <!-- Header -->
    <mat-card-header class="card-header">
      <div
        class="icon-container"
        mat-card-avatar
        [style.background-color]="getIconBackgroundWithOpacity()"
      >
        <img [src]="data.icon" [alt]="data.title" class="icon" />
      </div>
      <mat-card-title class="title">{{ data.title }}</mat-card-title>
      @if (data.subtitle) {
        <mat-card-subtitle class="subtitle">{{ data.subtitle }}</mat-card-subtitle>
      }
    </mat-card-header>

    <mat-divider class="divider-top" />

    <!-- Content -->
    <div class="content-wrapper">
      <mat-card-content class="content">
        @for (item of data.items; track $index) {
          <div class="item-row">
            <span class="item-name">{{ item.name }}</span>
            <span class="item-value">{{ data.comingSoon ? '-' : formatValue(item.value) }}</span>
          </div>
        }
      </mat-card-content>
    </div>

    <mat-divider class="divider-bottom" />

    <!-- Actions -->
    <mat-card-actions class="button-container">
      <!-- Botão de Informação (esquerda) -->
      @if (!hasMask) {
        <button
          mat-icon-button
          class="info-button"
          [attr.data-tooltip]="data.tooltipText || 'Informações adicionais'"
          [class.tooltip-active]="activeTooltipButton === 'info'"
          (click)="onInfoButtonClick($event)"
        >
          <img src="assets/icons/infoIcon.png" alt="Informações" class="info-icon" />
        </button>
      }

      <!-- Espaço flexível entre os botões -->
      <div class="spacer"></div>

      @if (!hasMask) {
        <!-- Botão Ver Mais (direita) COM TRACKING - ícone antes do texto -->
        <button
          mat-button
          class="more-button"
          (click)="onButtonClick()"
          appTrackClick
          [trackEvent]="data.trackEvent || 'card_button_click'"
          [trackCategory]="data.trackCategory || 'dashboard'"
          [trackLabel]="data.trackLabel || data.title"
        >
          <mat-icon class="button-icon">arrow_forward</mat-icon>
          <span>{{ getButtonText() }}</span>
        </button>
      }
    </mat-card-actions>
  </mat-card>
</app-card-mask>
